import React from 'react';
import {StyleButton} from './Styled';
import { CircularProgress, SxProps, Theme } from '@mui/material';

interface CustomButtonProps {
    title: string;
    onClick?: () => void;
    variant?: 'contained' | 'outlined';
    style?: any;
    disabled?: boolean;
    isLoading?: boolean;
    sx?: SxProps<Theme>;
}

const CustomButton = ({
    title,
    onClick,
    variant,
    style,
    disabled,
    isLoading = false,
    sx
} : CustomButtonProps) => {
    return (
        <StyleButton 
            variant={variant} 
            onClick={onClick} 
            style={style}
            disabled={disabled || isLoading}
            sx={sx}
        > 
            {isLoading && <CircularProgress size={16} color="inherit" />}
            {title}
        </StyleButton>
    );
}

export default CustomButton;
